import {
  FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_REQUEST,
  FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_SUCCESS,
  FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_FALUIRE,
} from './moveThermitUnitFronOnePlaceToAnotherTypes'

const initialState = {
  loading: false,
  isMoveThermitUnitSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_SUCCESS : return {
      ...state,
      isMoveThermitUnitSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_MOVE_THERMIT_UNIT_FROM_ONE_PLACE_TO_ANOTHER_FALUIRE : return {
      ...state,
      loading: false,
      isMoveThermitUnitSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
